/* eslint-disable no-nested-ternary */
export const linkposDefault = {
  Port: '10110',
  LogLevel: 'ERROR',
  LogFileName: 'linkpos-integration',
  SSLEnable: true,
  SSLKeyPath: 'cert/star_localhost_erply_com.key',
  SSLCertPath: 'cert/star_localhost_erply_com.crt',
  Production: true,
  LogToSentry: false,

  Websocket: false,
  DeviceTimeout: 60,
  PortName: 'COM1',
  BaudRate: 9600,
  DataBits: 8,
  StopBits: 1,
  ParityMode: 0,
  FlowControl: false,
  InterCharTimeout: 250,
  Bcc: false,
};

export const linkposFields = {
  DeviceTimeout: {
    id: 'DeviceTimeout',
    title: 'Device timeout',
    type: 'text',
    validate: (val) => (val < 0 ? 'Timeout must be positive' : null),
  },
  PortName: {
    id: 'PortName',
    title: 'Port Name',
    type: 'text',
    validate: (val) =>
      val?.toString().length ? null : 'Terminal IP address is required.',
  },
  BaudRate: {
    id: 'BaudRate',
    title: 'Baud Rate',
    type: 'text',
    validate: (val) => (val < 0 ? 'Baud rate must be positive' : null),
  },
  DataBits: {
    id: 'DataBits',
    title: 'Data Bits',
    type: 'text',
    validate: (val) => (val < 0 ? 'Data bits must be positive' : null),
  },
  StopBits: {
    id: 'StopBits',
    title: 'Stop Bits',
    type: 'text',
    validate: (val) => (val < 0 ? 'Stop bits must be positive' : null),
  },
  ParityMode: {
    id: 'ParityMode',
    title: 'Parity Mode',
    type: 'text',
    validate: (val) => (val < 0 ? 'Parity mode must be positive' : null),
  },
  FlowControl: {
    id: 'DataBits',
    title: 'Data Bits',
    type: 'checkbox',
  },
  InterCharTimeout: {
    id: 'InterCharTimeout',
    title: 'Inter char timeout',
    type: 'text',
    validate: (val) => (val < 0 ? 'Inter char timeout must be positive' : null),
  },
  Bcc: {
    id: 'Bcc',
    title: 'Bcc',
    type: 'checkbox',
  },
};
